import { type ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export function EarningsSkeleton(): ReactNode {
  return (
    <div className="space-y-sm">
      <Skeleton className="h-28 rounded-xl" />
      <div className="grid grid-cols-1 gap-sm md:grid-cols-3">
        <Skeleton className="h-24 rounded-xl" />
        <Skeleton className="h-24 rounded-xl" />
        <Skeleton className="h-24 rounded-xl" />
      </div>
      <Skeleton className="h-52 rounded-xl" />
      <div className="grid grid-cols-1 gap-sm md:grid-cols-2">
        <Skeleton className="h-36 rounded-xl" />
        <Skeleton className="h-36 rounded-xl" />
      </div>
    </div>
  );
}
